export interface LwSortState<T extends string> {
  col: T;
  dir: 'asc' | 'desc';
}

/**
 * Sortable table header cell. The sort control is a real `<button>` (keyboard
 * focusable, Enter/Space-activated) and the `<th>` carries `aria-sort` so
 * assistive tech announces the current sort. The arrow rotates and turns gold
 * when the column is active.
 */
export function LwTh<T extends string>({
  label,
  col,
  sort,
  onSort,
  align
}: {
  label: string;
  col: T;
  sort: LwSortState<T>;
  onSort: (col: T) => void;
  align?: 'right';
}) {
  const active = sort.col === col;
  return (
    <th
      className={`sortable${active ? ' sorted' : ''}${align === 'right' ? ' th-right' : ''}`}
      aria-sort={active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button type="button" className="th-sort" onClick={() => onSort(col)}>
        {label}
        <span className="arr" style={{ transform: active && sort.dir === 'asc' ? 'rotate(180deg)' : 'none' }}>
          <svg
            width={14}
            height={14}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M7 13l5-5 5 5" />
          </svg>
        </span>
      </button>
    </th>
  );
}
